export default function projectCards() {
  return {
    _id: false,
    type: 'droplet.projectCards',
    mediaQueries: [],
    visible: 6,
    showImage: true,
    loadMoreText: 'Load More',
    pageCSS: '',
    bounceDroplet: false,
    sortKey: false,
    isShared: false,
    templateRegion: false,
  };
}



// WEBPACK FOOTER //
// ./src/global-view/editor/droplets/project-cards/droplet.schema.js